export default __webpack_public_path__ + "static/media/Believer's Wraps of the Exalted Spirit.96881f13.jpg";